import { FC } from 'react';
import cn from 'bem-cn';

import { Stack } from '../../components/UI';
import { Header, HeaderElements } from '../../components/Header';
import { Footer } from '../../components/Footer';

import { NotFoundLayoutProps } from './NotFoundLayout.types';
import './NotFoundLayout.scss';

const b = cn('not-found-layout');

export const NotFoundLayout: FC<NotFoundLayoutProps> = ({ children }) => {
    const headerElements: HeaderElements = {
        desktop: {
            left: { type: 'logo' },
            right: { type: 'profile' },
        },
        mobile: {
            center: { type: 'logo' },
            right: { type: 'profile' },
        },
    };

    return (
        <Stack className={b()}>
            <div className={b('container')}>
                <Header elements={headerElements} />
                <div className={b('content')}>{children}</div>
            </div>
            <Footer />
        </Stack>
    );
};
